import { Fragment, useMemo } from "react";
import { DataProvider } from "../../shared/DataProvider";
import { isFlashCard } from "../../shared/utils";
import { IAnnotationData } from "../../shared/types";
import "./styles.scss";

interface IFlashcardsDrawer {
  annotationUpdated: boolean;
  onClose: () => void;
}

export const FlashcardsDrawer = ({ annotationUpdated, onClose }: IFlashcardsDrawer) => {
  const flashcardsByScreenId = useMemo(() => {
    const annotationsMap = DataProvider.getAnnotations() as Map<string, IAnnotationData[]>;
    const result: Record<string, IAnnotationData[]> = {};

    annotationsMap.forEach((annotations, screenId) => {
      const flashcards = annotations?.filter((annotation) => isFlashCard(annotation));

      if (flashcards.length) {
        result[screenId] = flashcards;
      }
    });

    return result;
  }, [annotationUpdated]);

  const clickHandler = (annotationData: IAnnotationData) => {
    window.__viewerApi.route(annotationData.screenId, { annotation: annotationData });
  };

  return (
    <div className="drawer flashcards-drawer">
      <div className="header">
        <h3 className="title">Flashcards</h3>
        <button className="close-button" aria-label="Close button" onClick={onClose}>
          <div className="close-icon" />
        </button>
      </div>

      <div className="drawer-body">
        {Object.keys(flashcardsByScreenId).map((screenId) => (
          <Fragment key={screenId}>
            {flashcardsByScreenId[screenId]?.map((annotationData) => (
              <div
                className="flashcard-item"
                key={annotationData.annotationId}
                onClick={() => clickHandler(annotationData)}
              >
                <div className="screen-title">{annotationData.screenTitle}</div>

                <div className="front-text">{annotationData.flashcardFrontText}</div>

                <div>{annotationData.flashcardBackText}</div>
              </div>
            ))}
          </Fragment>
        ))}
      </div>
    </div>
  );
};
